import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}
const _hoisted_3 = {
  key: 1,
  class: "text-red"
}
const _hoisted_4 = {
  key: 2,
  class: "text-red"
}

import { reactive } from 'vue'
import OnboardingPayslipUploadInput from './OnboardingPayslipUploadInput.vue'

interface FormParams {
  user: {
    nom: string
    prenom: string
    email: string
    telephone: string
  }
  photo: {
    preview?: string | ArrayBuffer | null
  } | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingPayslipDocumentsForm',
  props: {
    formParams: {},
    loading: { type: Boolean },
    hideHeader: { type: Boolean },
    hideTitle: { type: Boolean },
    hidePreviousLink: { type: Boolean }
  },
  emits: ["saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const formData = reactive({
  bulletin1: null as { file: File; name: string } | null,
  bulletin2: null as { file: File; name: string } | null,
  bulletin3: null as { file: File; name: string } | null
})

const errors = reactive<Record<string, string>>({
  bulletin1: '',
  bulletin2: '',
  bulletin3: ''
})

function validate() {
  let isValid = true
  Object.keys(errors).forEach(key => (errors[key] = ''))

  if (!formData.bulletin1) {
    errors.bulletin1 = 'Le bulletin 1 est requis'
    isValid = false
  }
  if (!formData.bulletin2) {
    errors.bulletin2 = 'Le bulletin 2 est requis'
    isValid = false
  }
  if (!formData.bulletin3) {
    errors.bulletin3 = 'Le bulletin 3 est requis'
    isValid = false
  }

  return isValid
}

function onFileUploaded(field: 'bulletin1' | 'bulletin2' | 'bulletin3', uploadedFile: { file: File; file_name: string }) {
  formData[field] = {
    file: uploadedFile.file,
    name: uploadedFile.file_name
  }
  // Émettre automatiquement les données mises à jour quand un fichier est uploadé
  // Cela permet de garder les données à jour dans le parent sans avoir besoin d'un bouton "Valider"
  emit('saved', { ...formData })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createVNode(OnboardingPayslipUploadInput, {
      id: "bulletin1-upload",
      onUploaded: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded('bulletin1', $event))),
      caption: ".1",
      label: "Bulletin de salaire (1)"
    }),
    (errors.bulletin1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(errors.bulletin1), 1))
      : _createCommentVNode("", true),
    _createVNode(OnboardingPayslipUploadInput, {
      id: "bulletin2-upload",
      onUploaded: _cache[1] || (_cache[1] = ($event: any) => (onFileUploaded('bulletin2', $event))),
      caption: ".2",
      label: "Bulletin de salaire (2)"
    }),
    (errors.bulletin2)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(errors.bulletin2), 1))
      : _createCommentVNode("", true),
    _createVNode(OnboardingPayslipUploadInput, {
      id: "bulletin3-upload",
      onUploaded: _cache[2] || (_cache[2] = ($event: any) => (onFileUploaded('bulletin3', $event))),
      caption: ".3",
      label: "Bulletin de salaire (3)"
    }),
    (errors.bulletin3)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errors.bulletin3), 1))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-6" }, " Format de fichier supporté: PDF, DOC, XLS. Taille max: 5MB. ", -1))
  ]))
}
}

})